import { render, staticRenderFns } from "./changeExam.vue?vue&type=template&id=60cbde33&"
import script from "./changeExam.vue?vue&type=script&lang=js&"
export * from "./changeExam.vue?vue&type=script&lang=js&"
import style0 from "./changeExam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports